import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { show_error, remove_flash, dataTruncate } from "lib/helpers"
import { initRemoveItemsHandler, checkboxesGroupController } from "lib/chat_bulk_actions"

// chat/bans/index — data-controller="chat--bans--index"
export default class extends Controller {
  static targets = ["table", "addButton", "banDialog"]

  static values = {
    bansPath: String,
    newBanPath: String,
    usersEditPath: String,
  }

  connect() {
    if (!this.hasTableTarget) return
    checkboxesGroupController("bans", "chatBans")
    this.#initDataTable()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    $(document).off(".chatBans")
    $("#check-all-bans").off(".chatBans")
    $(".table-checkbox").off(".chatBans")
  }

  addBan(event) {
    event.preventDefault()
    this.#loadResource(this.newBanPathValue)
  }

  editBan(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.banId
    this.#loadResource(`${this.bansPathValue}/${id}/edit`)
  }

  submitBanForm(event) {
    event.preventDefault()
    const form = $("#chat_ban_form")
    this.#sendBanForm(form)
  }

  #loadResource(path) {
    $.get(path, (data) => {
      $(this.banDialogTarget).html(data)
      $("#add-edit-ban").modal("show")
    })
  }

  #sendBanForm(form) {
    form.ajaxSubmit({
      dataType: "json",
      uploadProgress: (_event, _position, _total, percentComplete) => {
        form.find(".bar").width(`${percentComplete}%`)
      },
      beforeSubmit: () => {
        remove_flash()
        this.#waitMessage(form)
      },
      success: (response) => {
        form.find(".bar").width("100%")
        if (response.success) {
          $("#add-edit-ban").modal("hide")
          this.dataTable.draw(false)
        } else {
          show_error(response.message, form.parent())
        }
        this.#endWaitMessage(form)
      },
      error: () => {
        show_error("An error occurred during request!", form.parent())
        this.#endWaitMessage(form)
      },
    })
  }

  #waitMessage(form) {
    form.find(":submit").addClass("loading_submit").enable(false).next(".inline-loading").show()
  }

  #endWaitMessage(form) {
    form.find(":submit").removeClass("loading_submit").enable(true).next(".inline-loading").hide()
  }

  #initDataTable() {
    const $table = $(this.tableTarget)

    this.dataTable = createTurboDataTable($table, {
      dom: 'l<"head-toolbar">rtip<"footer-toolbar">',
      scrollX: true,
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: true,
      ajax: { url: this.bansPathValue },
      initComplete: () => {
        this.#bindRowSelection()
        $(document).off("click.chatBans", "#add_ban_button").on("click.chatBans", "#add_ban_button", (e) => this.addBan(e))
        $(document).off("click.chatBans", "#dialog_submit").on("click.chatBans", "#dialog_submit", (e) => this.submitBanForm(e))
      },
      footerCallback: () => {
        $("#check-all-bans").attr("checked", false)
        $(document).off("click.chatBans", ".edit-ban").on("click.chatBans", ".edit-ban", (e) => this.editBan(e))
      },
      columnDefs: [
        {
          targets: 0,
          orderable: false,
          width: "25px",
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-chat-bans" id="check--bans${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--bans${cellData}"><label/>`,
            )
          },
        },
        {
          targets: 1,
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<a href="#" class="edit-ban" data-ban-id="${cellData}">${dataTruncate(cellData, 40)}</a>`,
            )
          },
        },
        {
          targets: 2,
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<a href="${this.usersEditPathValue}/edit/${cellData}">${dataTruncate(cellData, 15)}</a>`,
            )
          },
        },
        { targets: [0], sortable: false },
      ],
    })

    $(".head-toolbar").append($(this.addButtonTarget).remove())

    if ($("#reader").val() === "false") {
      $(".footer-toolbar").html('<br><br><a href="#" class="remove bans-remove">Remove selected</a>')
      initRemoveItemsHandler("bans", this.dataTable, "chatBans")
    }
  }

  #bindRowSelection() {
    $("#check-all-bans").on("change.chatBans", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-chat-bans").prop("checked", isChecked)
      $(".table-checkbox-chat-bans").closest("tr").toggleClass("selected-row", isChecked)
    })

    $(document).on("change.chatBans", ".table-checkbox-chat-bans", function () {
      const isChecked = $(this).prop("checked")
      $(this).closest("tr").toggleClass("selected-row", isChecked)
      const allChecked = $(".table-checkbox-chat-bans:checked").length === $(".table-checkbox-chat-bans").length
      $("#check-all-bans").prop("checked", allChecked)
    })

    $(".table-checkbox").on("change.chatBans", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-chat-bans").prop("checked", isChecked)
      $(".table-checkbox-chat-bans").closest("tr").toggleClass("selected-row", isChecked)
    })
  }
}
